module.exports = __webpack_public_path__ + "static/media/love-icon.2132cdc9.svg";